import React from 'react'
import { Outlet } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'

const PublicLayout = () => {
  return (
    <div className="min-h-screen background-gradient">
      <header className="w-full h-fit pt-9 px-9 pb-0 hidden md:block">
        <div className="">
          <a href="/">
            <img src="/images/logo.png" alt="Logo" className="w-64" />
          </a>
        </div>
      </header>

      <main>
        <AnimatePresence>
          <Outlet />
        </AnimatePresence>
      </main>

      <footer className="h-24 hidden md:block"></footer>
    </div>
  )
}

export default PublicLayout
